export default __webpack_public_path__ + "static/media/megento.0e83403f.svg";